import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Spine } from "pixi-spine";
import { AdvancedText } from "@westpierstudio/luma/utils/advancedtext";
import { Container, Sprite, Text } from "pixi.js";
import { BoundedContainer, ImplementBoundedContainer } from "utils/BoundedContainer";

export class WinLinesCount extends View {
    private spec: Record<string, any>;
    countBox: Sprite;
    lightCountBox: Sprite;
    flames: Spine & Container;
    text: Text | AdvancedText;
    textContainer!: BoundedContainer;

    constructor(services: GameServices, specKey: string) {
        super(services);

        const {factory, resources} = services;

        this.spec = resources.getSpec(`winlines`);
        if (specKey === `dragons`) {
            this.countBox = factory.createSprite(this.spec.dragonsWinlinesCount, this);
            this.lightCountBox = factory.createSprite(this.spec.lightDragonsWinlinesCount, this);
        } else {
            this.countBox = factory.createSprite(this.spec.pandasWinlinesCount, this);
            this.lightCountBox = factory.createSprite(this.spec.lightPandasWinlinesCount, this);
        }

        this.text = factory.createText(resources.getMessage(`winlineCount`), this.spec.winlinesCountText);

        this.spec = resources.getSpec(`reels`);
        if (specKey === `dragons`) {
            this.flames = factory.createSpine(this.spec.dragonsReels.flameSpine.boxDragon, this);
        } else {
            this.flames = factory.createSpine(this.spec.pandasReels.flameSpine.boxPanda, this);
        }

        this.startFlameAnimation();

        this.enableFlames();
    }

    enableFlames(): void {
        this.flames.visible = true;
        this.countBox.visible = false;
        this.lightCountBox.visible = true;

        this.text.setParent(this.lightCountBox);
        this.textContainer = ImplementBoundedContainer(this.text, this.services.resources.getSpec(`winlines`).maxBounds.linesCount);
        this.textContainer.update();
    }

    disableFlames(): void {
        this.flames.visible = false;
        this.countBox.visible = true;
        this.lightCountBox.visible = false;

        this.text.setParent(this.countBox);
        this.textContainer = ImplementBoundedContainer(this.text, this.services.resources.getSpec(`winlines`).maxBounds.linesCount);
        this.textContainer.update();
    }

    private startFlameAnimation(): void {
        this.flames.state.setAnimation(0, `reel-idle`, true);
    }
}
